/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteTagesplan$Params {

/**
 * ID des Tagesplan der inaktiv gesetzt werden soll
 */
  tagesplanId: string;
}

export function deleteTagesplan(http: HttpClient, rootUrl: string, params: DeleteTagesplan$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteTagesplan.PATH, 'delete');
  if (params) {
    rb.path('tagesplanId', params.tagesplanId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteTagesplan.PATH = '/v1/tagesplaene/{tagesplanId}';
